// Centralized attachment policy (§1) — the single place to change limits so every attachment
// surface (Risks, Dependencies, Escalations, Change Requests, ...) stays in sync. Both
// apps/api (multer file-filter + count check) and apps/web (client-side validation) import
// this rather than hardcoding the numbers locally.

export const ATTACHMENT_POLICY = {
  maxFiles: 5,
  maxFileSizeBytes: 10 * 1024 * 1024,
  allowedMimeTypes: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'image/png',
    'image/jpeg',
    'text/plain',
    'text/csv',
  ],
} as const;
